export default __webpack_public_path__ + "static/media/drump.8d14735f.png";